import { Box, Card, CardHeader, LinearProgress, Table, TableBody, TableContainer } from '@mui/material'
import React from 'react'
import Scrollbar from 'src/components/scrollbar'
import { TableHeadCustom, TableNoData, useTable } from 'src/components/table'
import TableLinkRow from './table-link-row'

const HEADLabels = [
    { id: "", label: "Sr#", width: 50 },
    { id: "contractor", label: "Contractor" },
    { id: "buildName", label: "Build Name", minWidth: 200 },
    { id: "stage", label: "Stage" },
    { id: "saleLead", label: "Sale Lead(s)" },
    { id: "buildLead", label: "Build Lead(s)" },
    { id: "estCompletion", label: "Est. Completion", align: 'center' },
    { id: "openQuestion", label: "Open Question", align: 'center' },

]



const TableLink = ({ title ,builds , currentPage}) => {

    const isLoading = false;

    const isFetching = false;

    const table = useTable({defaultRowsPerPage:7});

    return (

        <Card>
            <CardHeader title={title} sx={{ my: 1 }} />

            <TableContainer>
                <Scrollbar>
                    {isLoading || isFetching ? <Box sx={{ width: "100%" }}>
                        <LinearProgress />
                    </Box> :
                        <Table size={table.dense ? "small" : "medium"}>
                            <TableHeadCustom
                                headLabel={HEADLabels}
                                order={table.order}
                                orderBy={table.orderBy}
                                // rowCount={data?.body?.length}
                                onSort={table.onSort}
                            />
                            <TableBody>
                                {builds?.length > 0 ? builds?.map((item, index) => (
                                    <TableLinkRow
                                        key={index}
                                        row={item}
                                        serialNumber={(currentPage - 1) * table.rowsPerPage + index + 1}
                                        onEdit={() => { }}
                                        fromTableLink={true}
                                    />

                                )) : (
                                    <TableNoData notFound={true} />
                                )}
                            </TableBody>
                        </Table>
                    }
                </Scrollbar>
            </TableContainer >


        </Card>
    )
}

export default TableLink